import { render, staticRenderFns } from "./Emboss.vue?vue&type=template&id=278fca68"
import script from "./Emboss.vue?vue&type=script&lang=js"
export * from "./Emboss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports